import { Model } from '@vuex-orm/core'
import { DateTime } from 'luxon'
import Position from '../positions/model'
import Share from '../share/model'
import EducationPlanPosition from './EducationPlanPosition'


export default class EducationPlan extends Model {
    static get entity () {
        return 'educationPlans'
    }

    static fields () {
        return {
            id: this.uid(),
            positionId: this.string('').nullable(),
            folders: this.attr([]),
            //positions: this.attr([]),
            positions: this.belongsToMany(Position, EducationPlanPosition, 'educationPlanId', 'positionId'),
            title: this.string(''),
            description: this.string(''),
            timeLimit: this.number(0),
            questionCount: this.number(0),
            startDate: this.attr('').nullable(),
            endDate: this.attr('').nullable(),
            ownerOrganizationId: this.uid(),
            shares: this.hasMany(Share, 'educationPlanId'),
            //position: this.belongsTo(Position, 'positionId'),
        }


    }

    get secondsFromStart() {
        return DateTime.fromISO(this.startDate, {zone: 'UTC'})
    }
}
